import React, { Component } from 'react';
import { DebounceInput } from 'react-debounce-input';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';
import PropTypes from 'prop-types';

const propTypes = {
    workflowNavElementId: PropTypes.string
};

class EnterLast4SSNContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            last4SSN: false
        };
        this.handleSsnChange = this.handleSsnChange.bind(this);
    }

    handleSsnChange(event) {
        this.setState({ last4SSN: event.target.checkValidity() });
    }

    isNextEnabled() {
        return this.state.last4SSN;
    }

    render() {
        return (
            <div>
                <div className="asc-form-group">
                    <label className="asc-form-label" htmlFor="email">
                        Enter Last 4 Digits Of Your SSN
                    </label>
                    <DebounceInput
                        className="asc-form-input"
                        onChange={this.handleSsnChange}
                        debounceTimeout={700}
                        type="text"
                        name="last4SSN"
                        pattern="[0-9][0-9][0-9][0-9]"
                        placeholder="EX: 1234"
                        required
                    />
                </div>

                <WorkflowNavContainer
                    primaryButtonText="Submit"
                    primaryButtonSubmitEnabled={this.isNextEnabled()}
                    primaryButtonCaret={false}
                    elementId={this.props.workflowNavElementId}
                />
            </div>
        );
    }
}

EnterLast4SSNContainer.propTypes = propTypes;
export default EnterLast4SSNContainer;
